module.exports = __webpack_public_path__ + "static/img/arrow_left.176b3da.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/assets/arrow_left.png
// module id = QtCE
// module chunks = 0